import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { I18nProvider, detectLocale, preloadDictionary } from "./i18n";
import "./styles/globals.css";

const container = document.getElementById("root")!;

/*
 * 管理後台固定深色。它是工作用的介面，長時間盯著看，
 * 深色比較不累，也不需要跟著使用者的系統設定走。
 */
document.documentElement.classList.add("dark");

const root = createRoot(container);

/*
  字典先載好再掛載。

  字典改成動態 import 之後，Provider 只有英文是同步拿得到的。
  不先載的話，一個把後台設成日文的管理員每次開頁面都會先看到
  一次英文再換過去 —— 而換過去的那一刻整個版面會重排。

  等的時間和 React 自己的初始化重疊。英文使用者完全不受影響：
  en 在主 bundle 裡，preloadDictionary 立刻回傳。

  用 .then() 而不是 top-level await —— 建置目標裡有不支援它的
  瀏覽器版本，用了會讓 vite build 直接失敗。
*/
void preloadDictionary(detectLocale()).then(() =>
  root.render(
  <StrictMode>
    {/*
      I18nProvider 要包在最外面 —— 登入頁也在裡面。

      它原本根本沒有被 render 過（後台的 i18n 建好之後一個畫面
      都沒有接上去），所以缺 Provider 一直沒有後果。等到每一頁
      都走 t() 之後，第一個炸的就是登入頁：useI18n() 找不到
      context 直接 throw，而那一頁是進後台的唯一入口。
    */}
    <I18nProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </I18nProvider>
  </StrictMode>,
  ),
);
